import { SelectParameter } from '@drivingdoc/shared-types/reports';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Controller, useFormContext } from 'react-hook-form';

import SelectInput from 'components/FormInputs/SelectInput';

interface SelectParameterFieldProps {
  parameter: SelectParameter;
}

export default function SelectParameterField({ parameter }: SelectParameterFieldProps) {
  const { control } = useFormContext();
  const { config } = parameter;

  if (config.clearable) {
    return (
      <Grid size={12}>
        <Box>
          <Typography
            component={InputLabel}
            htmlFor={parameter.name}
            variant="subtitle1"
            color="text.primary"
            fontWeight={700}
          >
            {parameter.label}
          </Typography>
          {parameter.helpText && (
            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
              {parameter.helpText}
            </Typography>
          )}
          <Controller
            name={parameter.name}
            control={control}
            render={({ field, fieldState }) => (
              <Autocomplete
                options={config.options}
                getOptionLabel={(opt) => opt.label}
                value={config.options.find((o) => o.value === field.value) ?? null}
                onChange={(_, newValue) => field.onChange(newValue?.value ?? null)}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={config.placeholder}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
            )}
          />
        </Box>
      </Grid>
    );
  }

  const options = config.options.map((opt) => ({
    value: opt.value,
    label: opt.label,
  }));

  return (
    <Grid size={12}>
      <SelectInput
        name={parameter.name}
        label={parameter.label}
        options={options}
        required={parameter.required}
        helperText={parameter.helpText}
        placeholder={config.placeholder}
      />
    </Grid>
  );
}
